module.exports = __webpack_public_path__ + "img/zhuce.1034c848.png";